import { useState, useEffect, useContext } from 'react'
import { Context } from '../../../utils/context'
import { blue, cyan, purple } from "@material-ui/core/colors";
import { onGetActivationsData, onGetBalanceTransactionPieData, onGetCardholderPieChartData, onGetOpenCloseLoopTransactionPieData, onGetStackBarTransactionData, onGetCatalogs } from './customFunctions';
import { startOfMonth, endOfMonth, subMonths, parseISO, format } from 'date-fns';
import { modules } from '../../../utils/config'

const useReports = () => {
    const { axios, authData, permissions } = useContext(Context)
    const authToken = `Bearer ${authData.token}`

    const [loading, setLoading] = useState(false)
    const [initialized, setInitialized] = useState(false)


    const [groups, setGroups] = useState([])
    const [group_id, setGroupId] = useState()
    const [locations, setLocations] = useState([])
    const [location_id, setLocationId] = useState()
    const [start_date, setStartDate] = useState(subMonths(startOfMonth(new Date()),2))
    const [end_date, setEndDate] = useState(endOfMonth(new Date()))
    const [transactions, setTransactions] = useState([])
    const [masterTransaction, setMasterTransactions] = useState([])
    const [reportPermission, setReportPermission] = useState({})


     useEffect(() => {
        if (permissions && permissions.length > 0) {
            let grPermission = permissions.find(p => p.moduleId === modules.reports.id)
            setReportPermission(grPermission)
        }
    }, [permissions])

    const [pagination, setPagination] = useState({
        limit:20,
        offset:0
    })
    const [total_data, setTotalData] = useState(1)

    /// states for cards
    const [activation_data, setActivationData] = useState({
        approved:1,
        rejected:1,
        total:2
    })
    // Open and Close Loop Pie Chart Data
    const [ocl_data, setOCLData] = useState({
        open:1,
        close:1,
        total:0
    })

    const [balance_data, setBalanceData] = useState({
        casino:0,
        mastercard:0,
        commission:0
    })

    const [transactions_stackbar, setTransactionsStackbar] = useState([])

    const [cardholders_data, setCardholdersData] = useState({
        male:1,
        female:1,
        undefined:0
    })
    
    const catalogs = {
        activations:[
            {id:1, label:'Approved', color:blue[700]},
            {id:2, label:'Rejected', color:blue[100]},
        ],
        transactions:[
            {id:2000, label:'Balance OL-CL', color:purple[700]},
            {id:3000, label:'Balance CL-OL', color:purple[100]},
        ],
        cardholders:[
            {id:2000, label:'Male', color:cyan[700]},
            {id:3000, label:'Female', color:cyan[100]},
        ],
        details_transactions:[
            {id:3001, label:'Casino', color:purple[700]},
            {id:2000, label:'Mastercard', color:cyan[700]},
            {id:4000, label:'Commission', color:blue[900]},
        ]
    }

    useEffect(() => {
        const initModule = async () => {
            try {
                setLoading(true)
                axios.defaults.headers.common['Authorization'] = authToken

                const groups_response = await axios.get('/group/all')
                const _groups = onGetCatalogs(groups_response.data.data, 'idGroup', 'description')
                const _group_id = _groups.length ? _groups[0].value : null
                setGroups(_groups)
                setGroupId(_group_id)
                if (_group_id) {
                    const locations_response = await axios.get(`/merchant/${_group_id}`)
                    const _locations = onGetCatalogs(locations_response.data.data, 'idMerchant', 'description')
                    const _location_id = _locations.length ? _locations[0].value : null
                    setLocations(_locations)
                    setLocationId(_location_id)
                }
            } catch (error) {
                console.log(error)
            }
            setLoading(false)
            setInitialized(true)   // <- se marca al final, cuando ya todo está resuelto
        }
        initModule()
    }, [])

    useEffect(() => {
        if (!initialized) return   // <- no dispares fetch de transacciones hasta terminar el init
        const onRequestData = async () => {
        setLoading(true)
        const { offset, limit } = pagination
        try {
            axios.defaults.headers.common['Authorization'] = authToken
            let params = { idGroup: group_id, idMerchant: location_id }
            const _start_date = start_date.toISOString()
            const _end_date = end_date.toISOString()
            const transactions_request = await axios.get(
                `/report/transaction/${offset * limit}/${limit}/${_start_date}/${_end_date}`,
                { params: { ...params } }
            )
                console.log('Request')
                console.log(transactions_request)
                setTotalData(transactions_request.data.data.totalRegistries)
                let _transactions_data = [...transactions_request.data.data.registries]
                //let _transactions_data = onFilterData(transactions_request.data.data.registries, group_id, location_id)
                const _activation_data = onGetActivationsData(_transactions_data)
                setActivationData(_activation_data)
                
                //transTypes = '2000'
                //params = {transTypes: transTypes}
                //const cl_op_request = await axios.get(`/report/transaction/${offset*limit}/${limit}/${_start_date}/${_end_date}`, {params:{...params}})
                //transTypes = '3000'
                //params = {transTypes: transTypes}
                //const op_cl_request = await axios.get(`/report/transaction/${offset*limit}/${limit}/${_start_date}/${_end_date}`, {params:{...params}})

                const cl_op_request = []
                const op_cl_request = []
               //let registers = [...op_cl_request.data.data.registries, ...cl_op_request.data.data.registries]
                let registers = []
                registers = onFilterData(registers, group_id, location_id)
                setTransactions(_transactions_data)
                const _loops_transactions = onGetOpenCloseLoopTransactionPieData(_transactions_data)

                setOCLData(_loops_transactions)

                const _balance_transactions = onGetBalanceTransactionPieData(_transactions_data)
                setBalanceData(_balance_transactions)

                const _transactions_stackbar = onGetStackBarTransactionData( group_id, locations, [..._transactions_data])
                setTransactionsStackbar(_transactions_stackbar)

                params = {Limit:1000000}
                if(group_id) params.IdGroup = group_id
                if(location_id) params.IdMerchant = location_id
                //const cardholders_request = await axios.get(`/cardholder/all`, {params:{...params}})
                //const _cardholders_data = onGetCardholderPieChartData(cardholders_request.data.data.data)
                //setCardholdersData(_cardholders_data)

                //let _master_transactions = []
                //if(_transactions_data) _master_transactions = [..._master_transactions, ..._transactions_data]
                //if(registers) _master_transactions = [..._master_transactions, ...registers]
                setMasterTransactions(_transactions_data)


            } catch (error) {
                console.log(error)
            }
            setLoading(false)
        }
        onRequestData()
    },[group_id, location_id,start_date, end_date, pagination])

    const onFilterData = (data, idGroup, idMerchant) => {
        let result = []
        console.log(`Filter by group ${idGroup} and by merchant ${idMerchant}`)
        console.log(data)
        data.forEach(item => {
            if(item.idGroup){
                if(item.idMerchant){
                    if(item.idGroup === idGroup && item.idMerchant === idMerchant) result.push(item)
                }else{
                    if(item.idGroup === idGroup) result.push(item)
                }
            }else{
                result.push(item)
            }
        })
        return result
    }

    const actions = {
        onChangeGroup: async(id) => {
            try {
                const locations_response = await axios.get(`/merchant/${id}`)
                const _locations = onGetCatalogs(locations_response.data.data, 'idMerchant', 'description')
                const _location_id = _locations.length ? _locations[0].value : null
                setLocations(_locations)
                setLocationId(_location_id)
                setGroupId(id)
            } catch (error) {
                console.log(error)
            }
    
        },
        onChangeTablePagination: (_data) => {
            console.log(_data)
            setPagination(_data)
        },
        onUpdateLocation: (val) => setLocationId(val),
        onUpdateStartDate: (val) => setStartDate(val),
        onUpdateEndDate: (val) => setEndDate(val)
    }

    const view_data = {groups, group_id, locations, location_id,start_date, end_date, transactions,
    activation_data, ocl_data, balance_data, transactions_stackbar, cardholders_data, masterTransaction, pagination, total_data} 
    const system = {loading}

    return {view_data, actions, system, catalogs, reportPermission} 
}

export default useReports